const mapping = {
    note: {
        counter: 'annotations',
        type: 'info',
        entity: 'annotation',
    },
    pinned: {
        counter: 'pinned',
        type: 'info',
        entity: 'pinned',
    },
    task: {
        counter: 'tasks',
        type: 'danger',
        entity: 'task',
    },
    email: {
        counter: 'emails',
        type: 'info',
        entity: 'email',
    },
    event: {
        counter: 'events',
        type: 'danger',
        entity: 'event',
    },
    phonecall: {
        counter: 'phonecalls',
        type: 'info',
        entity: 'phonecall',
    },
    marketing: {
        counter: 'marketing-events',
        type: 'info',
        entity: 'marketing',
    },
};

export { mapping };
